<template>
  <div>
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="$route.path" router>
          <el-menu-item index="/s/">
            <el-icon><Home /></el-icon>
            <span class="hidden-on-mobile">控制台</span>
          </el-menu-item>
          <el-menu-item index="/s/resume-management">
            <el-icon><Document /></el-icon>
            <span class="hidden-on-mobile">简历管理</span>
          </el-menu-item>
          <el-menu-item index="/s/job-management">
            <el-icon><Briefcase /></el-icon>
            <span class="hidden-on-mobile">岗位匹配</span>
          </el-menu-item>
          <el-menu-item index="/s/interview">
            <el-icon><ChatLineRound /></el-icon>
            <span class="hidden-on-mobile">面试管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { Home, Document, Briefcase, ChatLineRound } from '@element-plus/icons-vue';
 
export default {
  components: {
    Home,
    Document,
    Briefcase,
    ChatLineRound,
}
};
</script>

<style scoped>
.hidden-on-mobile {
  display: block;
}

@media (max-width: 768px) {
  .hidden-on-mobile {
    display: none;
  }

  .el-aside {
    width: 64px !important;
  }

  .el-menu {
    width: 64px;
  }
}
</style>